var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDescending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.57337 8.33395L10.7858 16.2247C11.1844 16.6608 11.3837 16.8789 11.6437 16.9521C11.8705 17.016 12.1295 17.016 12.3563 16.9521C12.6163 16.8789 12.8156 16.6608 13.2142 16.2247L20.4266 8.33395C20.8267 7.89628 21.0267 7.67744 20.9971 7.49783C20.9714 7.34118 20.8418 7.19882 20.6406 7.10619C20.4101 7 20.0108 7 19.2124 7H4.7876C3.98916 7 3.58994 7 3.35935 7.10619C3.15823 7.19882 3.02865 7.34118 3.00286 7.49783C2.9733 7.67744 3.17332 7.89628 3.57337 8.33395Z",
    stroke: "#070707",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDescending);
export default __webpack_public_path__ + "static/media/arrow-descending.70ed208a912a43ede2647bbc612ad8db.svg";
export { ForwardRef as ReactComponent };